import { buildRoutePaths } from '@s/core';

const baseRoutePaths = buildRoutePaths({
  root: { path: '' },
} as const);

const portalRoutePaths = buildRoutePaths({
  features: {
    path: 'features',
    children: {
      payment: {
        path: 'payment',
      },
      filters: {
        path: 'filters',
      },
      codegen: {
        path: 'codegen',
      },
      socialAuth: {
        path: 'social-auth',
      },
      uploadFiles: {
        path: 'upload-files',
      },
      chats: {
        path: 'chats',
      },
    },
  },
  components: {
    path: 'components',
    children: {
      table: { path: 'table' },
      autocomplete: { path: 'autocomplete' },
      overlay: { path: 'overlay' },
      dialog: { path: 'dialog' },
      snackbar: { path: 'snackbar' },
    },
  },
} as const);

/** Route paths can be used throughout the project. */
export const routePaths = {
  ...baseRoutePaths,
  ...portalRoutePaths,
};
